import { render, staticRenderFns } from "./orderAssessList.vue?vue&type=template&id=2b417d5d&scoped=true&"
import script from "./orderAssessList.vue?vue&type=script&lang=js&"
export * from "./orderAssessList.vue?vue&type=script&lang=js&"
import style0 from "./orderAssessList.vue?vue&type=style&index=0&id=2b417d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b417d5d",
  null
  
)

export default component.exports